/* Ryan LP analytics: page-scoped events fired into gtag.
 * Matches the existing site pattern (typeof gtag check, event_category/event_label).
 * No external dependencies. Defensive: every observer/listener fails closed.
 */
(function () {
  'use strict';

  var LP_NAME = 'topical_ceiling';
  var CATEGORY = 'ryan_lp';

  function track(name, params) {
    try {
      if (typeof gtag === 'function') {
        var payload = Object.assign({ event_category: CATEGORY, lp_name: LP_NAME }, params || {});
        gtag('event', name, payload);
      }
    } catch (e) { /* swallow */ }
  }

  function getUtms() {
    var out = {};
    try {
      var p = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = p.get(k);
        if (v) out[k] = v.slice(0, 100);
      });
    } catch (e) { /* swallow */ }
    return out;
  }

  function init() {
    /* 1. lp_view ------------------------------------------------ */
    track('lp_view', Object.assign({ event_label: LP_NAME }, getUtms()));

    /* 2. Scroll depth: 25 / 50 / 75 / 100 ----------------------- */
    var depthFired = { 25: false, 50: false, 75: false, 100: false };
    var depthThresholds = [25, 50, 75, 100];
    var scrollScheduled = false;

    function onScroll() {
      if (scrollScheduled) return;
      scrollScheduled = true;
      window.requestAnimationFrame(function () {
        scrollScheduled = false;
        var doc = document.documentElement;
        var scrollable = Math.max(1, (doc.scrollHeight || 0) - (window.innerHeight || 0));
        var pct = ((window.scrollY || window.pageYOffset || 0) / scrollable) * 100;
        for (var i = 0; i < depthThresholds.length; i++) {
          var t = depthThresholds[i];
          if (!depthFired[t] && pct >= t) {
            depthFired[t] = true;
            track('scroll_depth_' + t, { event_label: String(t), depth_pct: t });
          }
        }
        if (depthFired[100]) {
          window.removeEventListener('scroll', onScroll);
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* 3. Time on page: 30s / 60s / 120s / 240s ------------------ */
    [30, 60, 120, 240].forEach(function (sec) {
      window.setTimeout(function () {
        track('time_on_page_' + sec + 's', { event_label: String(sec), seconds: sec });
      }, sec * 1000);
    });

    /* 4. CTA clicks: primary + final ---------------------------- */
    document.addEventListener('click', function (e) {
      var el = e.target.closest && e.target.closest('[data-track]');
      if (!el) return;
      var key = el.getAttribute('data-track');
      if (key === 'cta-primary') {
        track('cta_click_primary', { event_label: 'buy_module', cta_position: 'primary' });
      } else if (key === 'cta-final') {
        track('cta_click_final', { event_label: 'closing_cta', cta_position: 'final' });
      } else if (key === 'cta-sticky') {
        track('cta_click_sticky', { event_label: 'sticky_bar', cta_position: 'sticky' });
      } else if (key === 'cta-one-bag') {
        track('cta_click_one_bag', { event_label: 'one_bag_link', cta_position: el.closest('.rlp-final-section') ? 'final' : 'primary' });
      } else if (key === 'header-shop-link') {
        track('header_shop_click', { event_label: 'editorial_bar' });
      }
    });

    /* 5. FAQ expand --------------------------------------------- */
    var faqItems = document.querySelectorAll('.rlp-faq__item');
    Array.prototype.forEach.call(faqItems, function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        var summary = item.querySelector('summary');
        var qid = summary && summary.getAttribute('data-track');
        if (!qid) return;
        track('faq_expand', { event_label: qid, question_id: qid });
      });
    });

    /* 6. Sticky CTA bar visibility ------------------------------ */
    var stickyEl = document.querySelector('[data-rlp-sticky]');
    if (stickyEl) {
      // Trigger: show once the "permission" aside (which immediately follows
      // the skincare-supplement description) enters the viewport.
      var triggerEl = document.querySelector('.rlp-permission');
      var buyEl = document.querySelector('.rlp-buy-section');
      var finalEl = document.querySelector('.rlp-final-section');
      var legalEl = document.querySelector('.rlp-legal-section');
      var stickyScheduled = false;
      var stickyArmed = false;       // latches true once trigger passes
      var stickyShownOnce = false;

      function updateSticky() {
        if (stickyScheduled) return;
        stickyScheduled = true;
        window.requestAnimationFrame(function () {
          stickyScheduled = false;
          try {
            var vh = window.innerHeight || document.documentElement.clientHeight;

            if (!stickyArmed && triggerEl) {
              var t = triggerEl.getBoundingClientRect();
              if (t.top < vh * 0.85) stickyArmed = true;
            } else if (!triggerEl) {
              stickyArmed = true;
            }

            function isInView(el) {
              if (!el) return false;
              var rect = el.getBoundingClientRect();
              return rect.top < vh && rect.bottom > 0;
            }
            var inHideZone = isInView(buyEl) || isInView(finalEl) || isInView(legalEl);
            var shouldShow = stickyArmed && !inHideZone;
            stickyEl.setAttribute('data-visible', shouldShow ? 'true' : 'false');
            stickyEl.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
            if (shouldShow && !stickyShownOnce) {
              stickyShownOnce = true;
              track('sticky_cta_shown', { event_label: 'sticky_bar' });
            }
          } catch (e) { /* swallow */ }
        });
      }

      window.addEventListener('scroll', updateSticky, { passive: true });
      window.addEventListener('resize', updateSticky);
      updateSticky();
    }

    /* 7. Section-in-view: testimonials, buy module -------------- */
    if (typeof IntersectionObserver !== 'function') return;
    var seen = {};

    function observeOnce(el, eventName, label) {
      if (!el || seen[eventName]) return;
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting && !seen[eventName]) {
            seen[eventName] = true;
            track(eventName, { event_label: label });
            io.disconnect();
            break;
          }
        }
      }, { threshold: 0.25 });
      io.observe(el);
    }

    observeOnce(document.querySelector('.rlp-testi-section'), 'testimonial_view', 'testimonials');
    observeOnce(document.querySelector('.rlp-buy-section'), 'buy_module_view', 'buy_module');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
